import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=6eb12927&scoped=true"
var script = {}
import style0 from "./Block.vue?vue&type=style&index=0&id=6eb12927&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb12927",
  null
  
)

export default component.exports